import React, { useEffect, useState, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';
import { Box, Typography, TextField, Button, Avatar } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';
import logo from "../components/Logo/Colloquia_Logo.png";
import Tooltip from '@mui/material/Tooltip';

function GovPostCommentsPage() {
   const { id } = useParams();
   const [govPost, setGovPost] = useState(null);
   const [comments, setComments] = useState([]);
   const [newComment, setNewComment] = useState('');
   const history = useHistory();

   useEffect(() => {
       axios.get(`/govPost/${id}`)
           .then(res => setGovPost(res.data))
           .catch(err => console.error("Error loading case", err));
       }, [id]);

   // Fetch comments
   /*useEffect(() => {
   axios.get(`/govPost/${id}/comments`)
       .then(res => setComments(res.data))
       .catch(err => console.error("Error loading comments", err));
   }, [id]);*/
   const [cursor, setCursor] = useState(null);
   const [loading, setLoading] = useState(false);
   const [hasMore, setHasMore] = useState(true);
   const fetchComments = async () => {
       if (loading || !hasMore) return;
       try {
           setLoading(true);
           const res = await axios.get(`/govPost/${id}/comments`, {
               params: { cursor, limit: 10 }
           });
           setComments(prev => {
               const existingIds = new Set(prev.map(c => c._id));
               const newComments = res.data.comments.filter(c => !existingIds.has(c._id));
               return [...prev, ...newComments];
           });
           setCursor(res.data.nextCursor);
           setHasMore(res.data.hasMore);
       } catch (err) {
           console.error("Error loading comments", err);
       } finally {
           setLoading(false);
       }
   };
   useEffect(() => {
       setComments([]);
       setCursor(null);
       setHasMore(true);
   }, [id]);
   useEffect(() => {
       fetchComments();
   }, [id]);
   const observer = useRef();
   const lastCommentRef = useCallback(node => {
       if (loading) return;
       if (observer.current) observer.current.disconnect();
       observer.current = new IntersectionObserver(entries => {
           if (entries[0].isIntersecting && hasMore) {
           fetchComments();
           }
       });
       if (node) observer.current.observe(node);
   }, [loading, hasMore]);


   const handleSubmitComment = async () => {
       if (!newComment.trim()) return;

       try {
           const res = await axios.post(`/govPost/${id}/comment`, { 
                text: newComment, 
            }); // NOTE: single 'comment'

           //const commentRes = await axios.get(`/govPost/${id}/comments`);
           //setComments(commentRes.data);
           setComments(prev => [res.data, ...prev]);
           setNewComment('');
       } catch (err) {
           console.error("Error submitting comment", err);
       }
   };

   const toggleVote = async (postId) => {
       try {
           const res = await axios.post(`/govPost/${postId}/upvote`);
           const { upvotes, voted } = res.data;

           setGovPost(prevCase => ({
               ...prevCase,
               upvotes,
               voted
           }));
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
   };

   const toggleCommentVote = async (commentId) => {
       try {
           //const res = await axios.post(`/govPostComments/${commentId}/upvote`);
           const res = await axios.post(`/govPost/${id}/commentReplies/${commentId}/upvote`);

           //const commentRes = await axios.get(`/govPost/${id}/comments`);
           //setComments(commentRes.data);
           setComments(prev =>
                prev.map(c =>
                    c._id === commentId
                    ? { ...c, upvotes: res.data.replyUpvotes, voted: res.data.replyVoted }
                    : c
                )
            );

       } catch(err) {
           console.error("Vote error", err);
       }
   };

   const visitProfile = (e, userId) => {
        e.stopPropagation(); // prevent opening the post
        history.push(`/user/view/${userId}`);
    };

   if (!govPost) {
     return <div>Loading post...</div>;
   }

   const navItems = [
        {
            label: "Popular Opinion",
            path: "/Government/popular",
            matchPaths: ["/Government/popular"]
        },
        {
            label: "Following",
            path: "/Government/following",
            matchPaths: ["/Government/following"]
        },
        {
            label: "Supreme Court",
            path: "/Government/SupremeCourt",
            matchPaths: [
            "/Government/SupremeCourt",
            "/scotusCase"
            ]
        },
        {
            label: "Congressional Bills",
            path: "/Government/CongressionalBills",
            matchPaths: ["/page2/b"]
        },
        {
            label: "State Legislature Bills",
            path: "/Government/StateBills",
            matchPaths: ["/Government/StateBills"]
        },
        {
            label: "Elections",
            path: "/Government/Elections/GubernatorialElections",
            matchPaths: ["/Government/Elections"]
        }
    ];

    const location = useLocation();
    const modeFromState = location.state?.mode;
    /*
    const isActive = (item) => {
        return item.matchPaths.some((match) =>
            location.pathname.startsWith(match)
        );
        };

        const getButtonStyles = (item) => {
        const active = isActive(item);

        return {
            padding: "6px 12px",
            borderColor: active ? "#1f1f1f" : "#333333",
            color: active ? "#1f1f1f" : "#333333",
            backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
            fontWeight: active ? 600 : 500,
            transition: "all 0.15s ease",
            "&:hover": {
            borderColor: "black",
            color: "black",
            backgroundColor: "rgba(0,0,0,0.12)"
            }
        };
    };*/
    const isActive = (item) => {
        // If we came from a mode, ONLY use that
        if (modeFromState) {
            return (
                (modeFromState === "popular" && item.label === "Popular Opinion") ||
                (modeFromState === "following" && item.label === "Following")
            );
        }

        // Otherwise fallback
        return item.matchPaths?.some((match) =>
            location.pathname.startsWith(match)
        );
    };

    const getButtonStyles = (item) => {
        const active = isActive(item);

        return {
            padding: "6px 12px",
            borderColor: active ? "#1f1f1f" : "#333333",
            color: active ? "#1f1f1f" : "#333333",
            backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
            fontWeight: active ? 600 : 500,
            transition: "all 0.15s ease",
            "&:hover": {
                borderColor: "black",
                color: "black",
                backgroundColor: "rgba(0,0,0,0.12)"
            }
        };
    };

    return (
       <div
          style={{
              padding: '20px',
              backgroundColor: '#FFFDF8',
              minHeight: '100vh',  // ensures it covers the full viewport height
              boxSizing: 'border-box', // ensures padding doesn't affect layout
          }}
      >

          <div style={{ width: '200px' }}></div>        

          {/*<Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              gap={2}
              flexWrap="wrap"
              sx={{
                  mt: 4,
                  mb: 4,
              }}
                  >
                    <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/a')}
                   >
                       Popular Opinion
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/d')}
                   >
                       Following
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/supremeCourtCases')}
                   >
                       Supreme Court
                   </Button>
                   <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page2/b/b2')}
                    >
                        Congressional Bills
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page2/CaliforniaBills')}
                    >
                        State Legislature Bills
                    </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/c')}
                   >
                       Elections
                   </Button>
           </Box>*/}
           {/* Sticky Navigation */}
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1000,
                  backgroundColor: "#FFFDF8",
                  //borderBottom: "1px solid rgba(0,0,0,0.08)",
                  py: 2
                }}
              >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  gap={2}
                  flexWrap="wrap"
                >
                  {navItems.map((item) => (
                    <Button
                      key={item.path}
                      variant="outlined"
                      sx={getButtonStyles(item)}
                      onClick={() => history.push(item.path)}
                    >
                      {item.label}
                    </Button>
                  ))}
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
              </Box>
           <Box
               p={2} // padding inside box
               my={2} // vertical margin between posts
               border="1px solid #ccc" // light grey border
               borderRadius="8px" // rounded corners
               sx={{
                   position: "relative",
                   maxWidth: 900, // limit width
                   mx: "auto", // center horizontally
                   my: 2, // vertical spacing between each post
               }}
           >
                <Box display="flex" alignItems="flex-start" gap={1}>
                       <Avatar
                           src={govPost.author?.profileImageUrl || '/default-avatar.jpg'}
                           alt={`${govPost.author?.first_name || ''} ${govPost.author?.last_name || ''}`}
                           onClick={(e) => visitProfile(e, govPost.author?._id)}
                           sx={{ 
                            width: 62, 
                            height: 62,
                            cursor: "pointer",
                            "&:hover": {
                                backgroundColor: "#d9e4f0",
                            }, 
                            }}
                       />
                       <Box>
                           <Typography variant="subtitle1" fontWeight="bold"
                           onClick={(e) => visitProfile(e, govPost.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "inline-block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "currentColor", 
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                           >
                           {govPost.author?.first_name && govPost.author?.last_name
                               ? `${govPost.author.first_name} ${govPost.author.last_name}`
                               : 'Unknown Name'}
                           </Typography>
                           <Typography variant="body2" color="text.secondary"
                           onClick={(e) => visitProfile(e, govPost.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "#currentColor",
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                           >
                           @{govPost.author?.username || 'unknown'}
                           </Typography>

                           <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                               {govPost.content}
                           </Typography>
            
                           <Typography
                                variant="caption"
                                color="text.secondary"
                                sx={{ display: "block", mt: 0.5 }}
                            >
                                {`${new Date(govPost.created_at).toLocaleString()}, ${
                                    govPost.commentCount
                                } ${govPost.commentCount === 1 ? 'reply' : 'replies'}`}
                            </Typography>

                       </Box>
                   </Box>

                   <Box mt={2} display="flex" alignItems="center" gap={1}>
                        {govPost.voted ? (
                            <Box
                               sx={{
                                   position: "relative",
                                   display: "inline-flex",
                                   alignItems: "center",
                                   "&:hover .voted-btn": {
                                       opacity: 0,
                                   },
                                   "&:hover .undo-btn": {
                                       opacity: 1,
                                       pointerEvents: "auto",
                                   },
                               }}
                           >
                                <Button
 					                size="small"
                                    className="voted-btn"
                                    variant="contained"
                                    color="success"
                                    disabled
                                    sx={{
                                       transition: "opacity 0.2s ease",
                                    }}
                                >
                                   Power Voted
                               </Button>
                               <Button
                                    size="small"
                                    className="undo-btn"
                                    variant="contained"
                                    color="error"
                                    sx={{
                                       inset: 0,
                                       position: "absolute",
                                       transition: "opacity 0.2s ease",
                                       opacity: 0,
                                       pointerEvents: "none",
                                   }}
                                   onClick={(e) => {
                                       e.stopPropagation();
                                       toggleVote(govPost._id)
                                   }}
                               >
                                    Undo
                               </Button>
                           </Box>
                        ) : (
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={(e) => {
                                e.stopPropagation();
                                toggleVote(govPost._id)}
                            }
                            >
                                ▲ Power Vote
                            </Button>
                        )}
                        <Typography variant="body2">{govPost.upvotes} Power Votes</Typography>
                   </Box>
           </Box>

           <Box
               p={2} // padding inside box
               my={2} // vertical margin between posts
               border="1px solid #ccc" // light grey border
               borderRadius="8px" // rounded corners
               sx={{
                   position: "relative",
                   maxWidth: 900, // limit width
                   mx: "auto", // center horizontally
                   my: 2, // vertical spacing between each post
               }}
           >
           <TextField
               fullWidth
               multiline
               rows={2}
               placeholder="Engage in intellectual discourse..."
               value={newComment}
               onChange={e => setNewComment(e.target.value)}
           />
           <Button variant="outlined" sx={{ mt: 1 }} onClick={handleSubmitComment}>
               Reply
           </Button>
           </Box>

           {comments.length === 0 ? (
               <Typography></Typography>
           ) : (
               comments.map((comment, i) => {
                const isLast = i === comments.length - 1;
                return (
               <Box
                   p={2} // padding inside box
                   ref={isLast ? lastCommentRef : null}
                   onClick={() => history.push(`/govPost/${id}/comments/${comment._id}`, { mode: modeFromState })}
                   my={2} // vertical margin between posts
                   border="1px solid #ccc" // light grey border
                   borderRadius="8px" // rounded corners
                   sx={{
                       position: "relative",
                       maxWidth: 900, // limit width
                       mx: "auto", // center horizontally
                       my: 2, // vertical spacing between each post
                       cursor: "pointer",
                       "&:hover": {
                           backgroundColor: "#f9f9f9"
                       }
                   }}
           >

                   <Box display="flex" alignItems="flex-start" gap={1}>
                               <Avatar
                                   src={comment.author?.profileImageUrl || '/default-avatar.jpg'}
                                   alt={`${comment.author?.first_name || ''} ${comment.author?.last_name || ''}`}
                                   onClick={(e) => visitProfile(e, comment.author?._id)}
                                    sx={{ 
                                        width: 62, 
                                        height: 62,
                                        cursor: "pointer",
                                        "&:hover": {
                                            backgroundColor: "#d9e4f0",
                                        }, 
                                        }}
                               />
                               <Box>
                                   <Typography variant="subtitle1" fontWeight="bold"
                                   onClick={(e) => visitProfile(e, comment.author?._id)}
                                    sx={{
                                        cursor: "pointer",
                                        display: "inline-block",
                                        "&:hover": {
                                        textDecoration: "underline",
                                        textDecorationColor: "currentColor", 
                                        textUnderlineOffset: "3px",
                                        },
                                    }}
                                   >
                                   {comment.author?.first_name && comment.author?.last_name
                                       ? `${comment.author.first_name} ${comment.author.last_name}`
                                       : 'Unknown Name'}
                                   </Typography>
                                   <Typography variant="body2" color="text.secondary"
                                   onClick={(e) => visitProfile(e, comment.author?._id)}
                                    sx={{
                                        cursor: "pointer",
                                        display: "block",
                                        "&:hover": {
                                        textDecoration: "underline",
                                        textDecorationColor: "#currentColor",
                                        textUnderlineOffset: "3px",
                                        },
                                    }}
                                   >
                                   @{comment.author?.username || 'unknown'}
                                   </Typography>

                                   <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                                       {comment.text}
                                   </Typography>

                                    <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                                        {`${new Date(comment.created_at).toLocaleString()}, ${
                                            comment.replyCount ?? 0
                                        } ${comment.replyCount === 1 ? "reply" : "replies"}`}
                                    </Typography>

                               </Box>
                           </Box>

                           <Box mt={2} display="flex" alignItems="center" gap={1}>
                            {comment.voted ? (
                                <Box
                                sx={{
                                    position: "relative",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    "&:hover .voted-btn": {
                                        opacity: 0,
                                    },
                                    "&:hover .undo-btn": {
                                        opacity: 1,
                                        pointerEvents: "auto",
                                    },
                                }}
                            >
                                    <Button
                                        size="small"
                                        className="voted-btn"
                                        variant="contained"
                                        color="success"
                                        disabled
                                        sx={{
                                        transition: "opacity 0.2s ease",
                                        }}
                                    >
                                    Power Voted
                                </Button>
                                <Button
                                        size="small"
                                        className="undo-btn"
                                        variant="contained"
                                        color="error"
                                        sx={{
                                        inset: 0,
                                        position: "absolute",
                                        transition: "opacity 0.2s ease",
                                        opacity: 0,
                                        pointerEvents: "none",
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleCommentVote(comment._id)
                                    }}
                                >
                                        Undo
                                </Button>
                            </Box>
                            ) : (
                                <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={(e) => {
                                    e.stopPropagation();
                                    toggleCommentVote(comment._id)}
                                }
                                >
                                    ▲ Power Vote
                                </Button>
                            )}
                            <Typography variant="body2">{comment.upvotes} Power Votes</Typography>
                    </Box>

               </Box>
               )})
           )}
    </div>
);
}

export default GovPostCommentsPage;